export default __webpack_public_path__ + "static/media/i54.27a08454.svg";